export default __webpack_public_path__ + "static/media/desktop_default_photo.5efa95be.svg";